/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { type BodyOf, tasksV1CardsEmailCreate } from '../fetch-client';
import { useFetchOpts } from '../use-fetch-opts';

export namespace ShareTaskViaEmail {
  export type Input = {
    id: string;
    emails: string[];
  };
  export type Output = void;

  function bodyFromInput(input: Input): BodyOf<typeof tasksV1CardsEmailCreate> {
    return {
      uuid: input.id,
      cardSendEmailViewInputRequest: {
        recipient_emails: input.emails,
      },
    };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        await ok(tasksV1CardsEmailCreate(body, opts));
        return;
      },
    });
  }
}
